import React, { useState } from "react";

import { Fulfillment } from "@secondcloset/types";

import { AmazonOutlined } from "@ant-design/icons";
import { Button } from "antd";

import { CreateShipmentDevToolModal } from "./CreateShipmentDevToolModal";

interface CreateShipmentDevToolButtonProps {
  order: Fulfillment.Order<"V2">;
  orderItems: Fulfillment.OrderItem<"V2">[];
  onRefetchOrder: () => void;
}

export const CreateShipmentDevTool: React.FC<CreateShipmentDevToolButtonProps> = ({
  order,
  orderItems,
  onRefetchOrder,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      <Button onClick={() => setIsVisible(true)} icon={<AmazonOutlined />}>
        Create Shipment Dev Tool
      </Button>
      <CreateShipmentDevToolModal
        order={order}
        orderItems={orderItems}
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        onRefetchOrder={onRefetchOrder}
      />
    </>
  );
};
